import { Route, Routes } from 'react-router-dom';
import SystemManagementPage from './system-management';
import SystemViewPage from './system_view';

const SystemManagement: React.FC = () => {
  return(
  <Routes>
    <Route path='' element= {<SystemManagementPage/>}/>
    <Route path=':systemId' element={<SystemViewPage/>}/>
  </Routes>
  )
}

export default SystemManagement